<template>
  <div
    :class="[
      'item-adder dashed-border d-flex flex-column justify-content-center align-items-center rounded',
      {
        slim,
        inactive: disabled,
        'dashed-border-inactive': disabled,
        'item-adder-transparent': transparent
      },
    ]"
    @click="handleClick"
  >
    <div
      class="center-circle d-flex justify-content-center align-items-center rounded-circle"
    >
      <i
        class="far fa-plus-circle"
        :class="{ inactive: disabled }"
        aria-hidden="true"
        data-cy="create"
      ></i>
    </div>
    <span>{{ text }}</span>
  </div>
</template>

<script>
export default {
  emits: ["click"],
  props: {
    text: {
      type: String,
      default: "",
    },
    slim: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    transparent: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
.item-adder {
  width: 200px;
  height: 70%;
  min-height: 100px;
  cursor: pointer;
  color: var(--primary-color);
  font-weight: bold;
  font-size: 0.9rem;
  align-self: center;
  background-color: #fff;

  &.slim {
    flex-direction: row !important;
    font-size: 0.8rem;
    height: 35px !important;
    min-height: 35px !important;
    .center-circle {
      margin-right: 5px;
      margin-bottom: 0;
      .fa-plus-circle {
        font-size: 1rem;
      }
    }
  }

  &.item-adder-transparent {
    background-color: transparent;
  }
}

.center-circle {
  margin-bottom: 5px;
}

.dashed-border {
  border: 3px dashed var(--primary-color);
}

.dashed-border-inactive {
  border: 3px dashed var(--medium-color);
  cursor: default;
}

.fa-plus-circle {
  font-size: 1.3rem;
  color: var(--primary-color);
}

.inactive {
  color: var(--medium-color) !important;
}
</style>
